export default __webpack_public_path__ + "static/footerBg-b63b9c487a61caca3a30290f36038e73.svg";